import styled from 'styled-components';

export const Container = styled.div`
display: flex;
flex-direction: column;
justify-content: center;
width: auto;
min-height: 93px;
background: #fff;
border: 1px solid #D8D8E8;
border-radius: 12px;
margin:20px 0;
padding:0 27px;
`
export const ContentHeader = styled.div`
display: flex;
width: 100%;
min-height: 89px;
flex-direction: row;
align-items: center;
justify-content:space-between;
`

export const Row = styled.div`
display: inline-flex;
align-items: center;
`

export const Label = styled.span`
font-family: 'Poppins';
font-style: normal;
font-weight: 600;
font-size: 18px;
line-height: 27px;
color: #23314B;
`

export const SucceedBox = styled.div`
width: 141px;
height: 22px;
background: #A9B8CD;
border-radius: 23px;
display: inline-flex;
justify-content: center;
align-items: center;
margin-left: 20px;
`

export const SucceedLabel = styled.span`
font-family: 'Poppins';
font-style: normal;
font-weight: 500;
font-size: 12px;
line-height: 12px;
color: #FFFFFF;
`

export const Icon = styled.img`
margin-right: 18px;
`

export const ExpandButton = styled.button`
background:none;
`

export const EmptyDivider = styled.div`
height:40px;
`